import { defineComponent as g, computed as e, useCssModule as v, openBlock as n, createElementBlock as c, normalizeStyle as $, normalizeClass as b, createElementVNode as S, mergeProps as d } from "vue";
import O from "../../utils/mapClasses.mjs";
import j from "../../utils/propValidator.mjs";
import h from "./styles/CdrImg.module.scss.mjs";
import k from "../../../_virtual/_plugin-vue_export-helper.mjs";
const P = g({
  name: "CdrImg",
  inheritAttrs: !1,
  props: {
    /**
     * Image source url.
     */
    src: {
      type: String,
      required: !0
    },
    /**
     * Image alt text. Defaults to an empty string
     */
    alt: {
      type: String,
      default: ""
    },
    /**
     * Aspect ratio of the media container
    * @demoSelectMultiple false
    * @values auto, square, 1-2, 2-3, 3-4, 9-16, 2-1, 3-2, 4-3, 16-9
    */
    ratio: {
      type: String,
      validator: (s) => ["auto", "square", "1-2", "2-3", "3-4", "9-16", "2-1", "3-2", "4-3", "16-9"].indexOf(s) >= 0 || !1
    },
    /**
    * Requires a `ratio`. Area to crop the image overflow to. {left, center, right} {top, center, bottom}
    * @demoSelectMultiple false
    * @values left, x-center, right, top, y-center, bottom
    */
    crop: {
      type: String
    },
    /**
    * Requires a `ratio`. Scale the image to be as large as possible to fill the area (background-position: cover;)
    */
    cover: {
      type: Boolean
    },
    /**
    * Adds a custom class to the cdr-img__ratio container div
    */
    containerClass: String,
    /**
    * Sets a border radius to an element {square, top, right, bottom, left}
    * @demoSelectMultiple false
    * @values circle, rounded
    */
    radius: {
      type: String,
      validator: (s) => ["circle", "rounded"].indexOf(s) >= 0 || !1
    },
    /**
     * Modifies the style variant for this component.
     * @demoSelectMultiple false
     * @values responsive
     */
    modifier: {
      type: String,
      default: "",
      validator: (s) => j(s, ["", "responsive"])
    }
  },
  setup(s) {
    const r = "cdr-image", t = "cdr-image-ratio", a = "cdr-image-ratio__cover", i = e(() => s.modifier && `${r}--${s.modifier}`), l = e(() => s.radius && `${r}--${s.radius}`), m = e(() => ({
      objectPosition: s.crop
    })), u = e(() => {
      let o;
      if (s.ratio === "square")
        o = "100%";
      else if (s.ratio === "auto")
        o = "0";
      else {
        const [p, y] = s.ratio.split("-");
        o = `${y / p * 100}%`;
      }
      return {
        "--ratio": o
      };
    }), C = e(() => s.crop && `${a}--crop`), f = e(() => s.cover && `${a}--cover`);
    return {
      style: v(),
      mapClasses: O,
      baseClass: r,
      ratioClass: t,
      coverWrapperClass: a,
      modifierClass: i,
      radiusClass: l,
      cropObject: m,
      ratioObject: u,
      cropClass: C,
      coverClass: f
    };
  }
}), q = ["src", "alt"], B = ["src", "alt"];
function M(s, r, t, a, i, l) {
  return s.ratio ? (n(), c("div", {
    key: 0,
    style: $(s.ratioObject),
    class: b([s.style[s.ratioClass], s.containerClass])
  }, [S("img", d({
    style: s.cropObject,
    class: s.mapClasses(s.style, s.baseClass, s.modifierClass, s.radiusClass, s.coverWrapperClass, s.cropClass, s.coverClass),
    src: s.src,
    alt: s.alt
  }, s.$attrs), null, 16, q)], 6)) : (n(), c("img", d({
    key: 1,
    class: s.mapClasses(s.style, s.baseClass, s.modifierClass, s.radiusClass),
    src: s.src,
    alt: s.alt
  }, s.$attrs), null, 16, B));
}
const z = {
  $style: h
}, V = /* @__PURE__ */ k(P, [["render", M], ["__cssModules", z]]);
export {
  V as default
};
